import { QueryKeys } from '@/constants/query-keys';
import { useQueryClient } from '@tanstack/react-query';

export const useClearCache = (): () => void => {
  const queryClient = useQueryClient();

  const handleClearCache = (): void => {
    Object.values(QueryKeys.user).forEach((queryKey) => {
      queryClient.removeQueries({ queryKey: queryKey as readonly string[] });
    });
  };

  return handleClearCache;
};
